import { Template } from "@/Contracts/Templates";

export const concatBlocksAndDraftBlockInTemplateResponse = (
	template: Template
): Template => {
	const newTemplate: Template = { ...template };
	if (newTemplate.blocks || newTemplate.draft_blocks) {
		const data = [
			...(newTemplate.blocks?.data ?? []),
			...(newTemplate.draft_blocks?.data ?? [])
		];
		newTemplate.blocks = { data };
		delete newTemplate.draft_blocks;
	}
	if (newTemplate.block_list || newTemplate.draft_block_list) {
		const blockList = [
			...newTemplate.block_list,
			...(newTemplate.draft_block_list ?? [])
		];
		newTemplate.block_list = blockList;
		delete newTemplate.draft_block_list;
	}
	return newTemplate;
};
